import { AuthProvider } from 'hooks/authProvider.jsx';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Routes from 'routes/index.jsx';
import './App.css';
import Loading from 'components/loading/index.jsx';

function App() {
  return (
    <>
      <Loading />
      <AuthProvider>
        <Routes />
      </AuthProvider>
      <ToastContainer />
    </>
  );
}

export default App;
